<template>
  <div>
    <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9900"
    >
    </v-overlay>
    <transition name="fade-slide">
      <output v-if="showSuccess" class="success-toast">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
      </output>
    </transition>
    <v-container fluid>
      <h2 style="color: #171717; font-weight: 600;">{{ $t('intentGroupInformation') }}</h2>
      <div class="mt-4">
        <hr />
      </div>
      <div class="label-style mt-4">
        <label for="">{{ $t('intentGroupName') }}</label>
        <span style="color: red; margin-left: 4px;">*</span>
        <v-tooltip location="top" max-width="230px">
          <template v-slot:activator="{ props }">
            <img
              v-bind="props"
              src="@/assets/intent group toolip.svg"
              alt="info"
              width="18"
              height="18"
              style="cursor: pointer; margin-left: 4px;"
            />
          </template>
          <span>{{ $t('_nameIntentGroupTooltip') }}</span>
        </v-tooltip>
      </div>
      <div class="d-flex align-center justify-start" style="gap: 16px;">
        <input
          id="groupintentname-intentsession"
          :aria-label="$t('intentGroupName')"
          v-model="IntentSession.Name"
          :placeholder="$t('intentGroupName')"
          :rules="[rules.required]"
          class="minimal-field"
          density="comfortable"
          required
        />
        <v-tooltip location="top" max-width="230px">
          <template v-slot:activator="{ props }">
            <button
            v-bind="props"
              id="button-savename-intentsession"
              class="btn-save"
              variant="elevated"
              @click="SaveName()"
            >
              <img src="@/assets/mage_save-floppy.svg" alt="img" width="20" height="20" />
              <span style="color: #C32E0E; font-weight: 500; font-size: 13px;">{{ $t("save") }}</span>
            </button>
          </template>
          <span>{{ $t('saveIntentGroupName') }}</span>
        </v-tooltip>
        
      </div>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center" style="margin-top: -24px;">
            <v-col cols="12" md="6">
              <h2 style="font-weight: 600; color: #171717;">{{ $t('intentSessionList') }}</h2>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
              <v-row align="center" justify="end" style="gap: 20px; margin-right: 0px;">
                <v-text-field
                  id="searchname-intentsession"
                  v-model="searchName"
                  :placeholder="$t('intentSessionName')"
                  density="comfortable"
                  variant="plain"
                  class="search-input"
                  hide-details
                  @input="Search"
                  @click:clear="clearSearch"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <v-tooltip location="top" max-width="260px">
                  <template v-slot:activator="{ props }">
                    <button
                      :style="!IntentSession.Name ? 'opacity: 0.4;' : 'opacity: 1;'"
                      class="add-btn"
                      @click="Add()"
                      type="button"
                      v-bind="props"
                      :id="'AddNewAction-intentsessiondetail'"
                    >
                      <img src="@/assets/ic_round-plus.svg" alt="img" class="img-icon">
                      <span style="color: #ffffff; margin-left: 6px; font-size: 13px;">{{ $t("addIntentSession") }}</span>
                    </button>
                  </template>
                  <span style="font-size: 14px;">{{ $t('addNewIntentSession') }}</span>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
          class="pa-4"
        >
          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">{{ $t('noDataAvailable') }}</span>
            </div>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <div class="action-group" style="justify-content: center; max-width: 120px;">
                  <!-- Edit -->
                  <v-btn
                    :id="'button-edit-intentsession-' + item.number"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                   
                  
                  <!-- Delete -->
                  <v-btn
                    :id="'button-delete-intentsession-' + item.number"
                    variant="text"
                    density="comfortable"
                    @click="openDeleteDialog(item)"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="20"
                          height="17"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('delete') }}</span>
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>

        <v-dialog v-model="showDeleteDialog" max-width="570">
          <v-card class="delete-dialog-card">
            <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
              <span class="dialog-title font-weight-bold">{{ $t('deleteIntentSession') }}</span>
              <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6 pb-4 px-4 body-text">
              {{ $t('_confirmDeleteIntentSession') }}
            </v-card-text>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
              <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">{{ $t('cancel') }}</button>
              <v-btn class="delete-confirm-btn" :loading="deleting" @click="Delete(item.intentSessionID)">
                <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                <p style="color: #ffffff; font-size: 11px; font-weight: 500;">{{ $t('delete') }}</p>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card>
    </v-container>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Name Required Dialog -->
    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t('_intentGroupNameRequired') }}</h3>
          <button type="button" @click="showNameRequiredDialog = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ $t('_fillIntentGroupNameCorrectly') }}</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showNameRequiredDialog = false" :id="'button-requiredname-ok'">{{ $t('ok') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showNameRequire" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t('_intentGroupNameRequired') }}</h3>
          <button type="button" @click="showNameRequire = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{$t("warningFillIntentGroupName")}}</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showNameRequire = false" :id="'button-requiredname-ok'">{{ $t('ok') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "IntentSession",
  inject: ["flagNav", "FontColorTitle","SubNavbarBackGround","Username", "RoleId"],
  components: {},
  mixins: [checkPermissionTwo],
  data() {
    return {
    showNameRequire: false,
    showNameRequiredDialog: false,
    showSuccess: false,
    showDeleteDialog: false,
    successMessage: '',
    _toastTimer: null,
    loadingTable: false,
    today: null,
    searchName: null,
    checkName: null,
    AddDataIntegration: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    files: [],
    uploadedFiles: [],
    DDDataType: [
      {
        id: "nvarchar",
        name: "nvarchar",
      },
      {
        id: "int",
        name: "int",
      },
      {
        id: "float",
        name: "float",
      },
      {
        id: "datetime",
        name: "datetime",
      },
      {
        id: "bit",
        name: "bit",
      },
    ],
    rules: {
      required: (value) => !!value || this.$t("Required"),
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    IntentSession: {
      IntentGroupID: null,
      Name: null,
    },
    };
  },
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false },
        {
          title: this.$t("intentSessionName"),
          value: "Name",
          align: "left",
          sortable: true,
        },
        {
          title: this.$t("createdBy"),
          value: "CreateBy",
          align: "left",
          sortable: true,
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "120px" },
      ];
    },
    rangeStart() {
      if (!this.searchTotalTable) return 0;
      return (this.options.page - 1) * this.options.itemsPerPage + 1;
    },
    rangeEnd() {
      if (!this.searchTotalTable) return 0;
      return Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable);
    },
    totalPages() {
      return this.searchTotalTable;
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openDeleteDialog(item) {
      this.item = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.item = null;
    },
    beforeUnmount() {
      clearTimeout(this._toastTimer);
    },
    btnDisableDelete(item) {
      return this.RoleId == 2 && item.createBy != this.Username;
    },
    Get() {
      if(this.$route.query.id)
      {
        this.IntentSession.IntentGroupID = this.$route.query.id;
      }
      if (
        this.IntentSession.IntentGroupID == null ||
        this.IntentSession.IntentGroupID == undefined
      ) {
        return;
      }
      this.loadingTable = true;
      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        DataName: this.searchName,
        IntentGroupID: this.IntentSession.IntentGroupID,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call.GetTableIntentSession(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            this.IntentSession.Name = dataResponse.data.name;
            this.checkName = dataResponse.data.name;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchName = null;
      this.options.page = 1;
      this.Get();
    },
    Delete(id) {
      this.dialog = true;
      this.deleting = true;
      this.$call.DeleteIntentSession(
        {
          IntentSessionID: id,
          IntentGroupID: this.IntentSession.IntentGroupID,
        },
        (dataResponse) => {
          this.dialog = false;
          this.deleting = false;
          this.showDeleteDialog = false;
          if (dataResponse.status == 0) {
            this.successMessage = this.$t('_intentSessionDeleted');
            this.showSuccess = true;
            clearTimeout(this._toastTimer);
            this._toastTimer = setTimeout(() => {
              this.showSuccess = false;
            }, 2000);
            this.Get();
          } else if (dataResponse.status == 1) {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
              confirmButtonText: this.$t("gotIt"),
              confirmButtonColor: "#d33",
            });
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.deleting = false;
          console.error(errorResource);
        }
      );
    },
    // Delete(id) {
    //   let self = this;
    //   try {
    //     self.$swal
    //       .fire({
    //         title: this.$t("ConfirmDeletion"),
    //         text: this.$t("confirmDeletionIntentSession"),
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: this.$t("confirm"),
    //         cancelButtonText: this.$t("cancel"),
    //         reverseButtons: false,
    //       })
    //       .then((result) => {
    //         if (result.isConfirmed) {
    //           self.dialog = true;
    //           self.$call.DeleteIntentSession(
    //             {
    //               IntentSessionID: id,
    //               IntentGroupID: self.IntentSession.IntentGroupID,
    //             },
    //             (dataResponse) => {
    //               if (dataResponse.status == 0) {
    //                 self.$swal.fire({
    //                   icon: "success",
    //                   title: dataResponse.message,
    //                   showConfirmButton: false,
    //                   timer: 1500,
    //                 });
    //                 self.Get();
    //               }
    //               self.dialog = false;
    //             },
    //             (errorResource) => {
    //               self.dialog = false;
    //               console.error(errorResource);
    //             }
    //           );
    //           self.Get();
    //         }
    //       });
    //   } catch (error) {
    //     this.LogTrace(error, "DeleteGroup");
    //   }
    // },
    Add() {
      if (!this.IntentSession.Name || this.IntentSession.Name.trim() === "") {
        this.showNameRequiredDialog = true;
        return;
      }
      if (this.IntentSession.Name != this.checkName) {
        this.showNameRequiredDialog = true;
        return;
      }
      if (
        this.IntentSession.IntentGroupID == null ||
        this.IntentSession.IntentGroupID == "" ||
        this.IntentSession.IntentGroupID == undefined
      ) {
        this.CreateGroupName(true);
      } else {
        this.$router.push({
          name: "IntentSessionDetail",
          query: {
            idGroup: this.IntentSession.IntentGroupID,
          },
        });
      }
    },
    Edit(item) {
      this.$router.push({
        name: "IntentSessionDetail",
        query: {
          id: item.intentSessionID,
          idGroup: this.IntentSession.IntentGroupID,
        },
      });
    },
    CreateGroupName(flagNextPage) {
      if (this.IntentSession.Name === "" || this.IntentSession.Name === null) {
        this.showNameRequire = true;
        return;
      }
      this.dialog = true;
      let temp = {
        Name: this.IntentSession.Name.trim(),
      };
      this.$call.CreateIntentGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.$router.push({
              name: "IntentSession",
              query: {
                id: dataResponse.data,
              },
            });
            if (dataResponse.data == 0) {
              this.$swal.fire({
                icon: "warning",
                title: this.$t("warning"),
                text: dataResponse.data.message,
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (flagNextPage) {
              this.$router.push({
                name: "IntentSessionDetail",
                query: {
                  idGroup: dataResponse.data,
                },
              });
            } else {
              this.IntentSession.IntentGroupID = dataResponse.data;
              this.successMessage = dataResponse.message;
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 2000);
            }
            this.checkName = this.IntentSession.Name
          }else if (dataResponse.status == 3) {
            this.$swal.fire({
              icon: "warning",
              title: this.$t("warning"),
              text: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          if (errorResource.status != 0) {
            console.error(errorResource);
          }
        }
      );
    },
    UpdateGroupName() {
      if (this.IntentSession.Name === "" || this.IntentSession.Name === null) {
        this.showNameRequire = true;
        return;
      }
      if (
        this.IntentSession.IntentGroupID == "" ||
        this.IntentSession.IntentGroupID == null ||
        (this.IntentSession.Name == null && this.IntentSession.Name == "")
      ) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.$t("warningFillIntentGroupName"),
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      this.dialog = true;
      let temp = {
        Name: this.IntentSession.Name.trim(),
        IntentGroupID: this.IntentSession.IntentGroupID,
      };
      this.$call.UpdateIntentGroup(temp, (dataResponse) => {
        if (dataResponse.status == 0) {
          this.successMessage = dataResponse.message;
          this.showSuccess = true;
          clearTimeout(this._toastTimer);
          this._toastTimer = setTimeout(() => {
            this.showSuccess = false;
          }, 2000);
          this.Get();
          this.checkName = this.IntentSession.Name
        }else if (dataResponse.status == 3) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: dataResponse.message,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.dialog = false;
      });
    },
    SaveName() {
      if (
        this.IntentSession.IntentGroupID == "" ||
        this.IntentSession.IntentGroupID == null
      ) {
        this.CreateGroupName(false);
      } else {
        this.UpdateGroupName();
      }
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
/* Required Name Dialog Styles */
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #A86400;
}
.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}

.required-name-dialog .close-btn {
  color: #B45800;
}

.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}

.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1D863C 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000 !important;
}
.body-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px !important;
  width: 120px;
  background: #C30000;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

.items-select :deep(.v-field) { 
  border-radius: 14px;
  margin-right: 6px;
}
.small-select :deep(.v-field) {
  min-height: 30px;
  height: 36px;
  padding: 0 4px;
}
.small-select :deep(.v-field__input) { 
  min-height: 30px; 
}
.items-select :deep(.v-field__input),
.items-select :deep(.v-select__selection-text),
.items-select :deep(.v-list-item-title) {
  font-size: 14px !important;
}
.dropdown-icon { 
  width: 20px;
  height: 20px;
  transition: transform .2s ease;
  margin-right: 4px;
}
.small-select.v-select--active-menu .dropdown-icon { 
  transform: rotate(180deg);
}

.btn-save {
  display: flex;
  justify-content: center !important;
  align-items: center;
  border: 1px solid #C32E0E;
  border-radius: 12px;
  padding: 10px;
  gap: 8px;
  width: 100px;
}
.btn-save:hover {
  background: #FDE4DF;
}
.search-input {
  height: 40px;
  max-width: 280px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 180px;
  gap: 2px;
  padding: 0 10px;
  height: 40px;
}
.img-icon {
  width: 22px;
  height: 22px;
}
.minimal-field{
  background: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  width: 40%;
  height: 44px;
  padding: 8px;
}
.minimal-field:focus {
  border: 1px solid #c9c9c9;
  outline: 0px solid #c9c9c9;
}
.minimal-field::placeholder {
  color: #CCCCCC;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.label-style {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}
</style>
